import {constructEnterpriseDetails, constructEnterpriseLevelsDetails} from "../Factory/factory";
import {findEnterpriseDetails} from "../Util/queries";
import {ENTERPRISE_LEVELS_DETAILS} from "../Reducers/enterpriseLevelsDetailsReducer";
import { ENTERPRISE_ADMIN_DETAILS } from "../Reducers/enterpriseDetailsReducer";
import { Role } from "../Model/userObjects";
import { OWN_ROLE } from "../Reducers/ownRoleReducer";

export const getEnterpriseDetails = () =>
    async (dispatch) => {
        try {
            let response = await findEnterpriseDetails();
            if (response.data) {
                let detailsData = response.data;
                detailsData.admin.billingDiscountAmount = detailsData.admin.billingDiscountAmount || 0; //might change later on.
                let enterpriseDetailsObj = constructEnterpriseDetails(detailsData.admin);
                let enterpriseLevelsDetailsObj = constructEnterpriseLevelsDetails(detailsData.enterprise);
                let ownRoleObj = new Role(detailsData.role);
                dispatch({
                    type: ENTERPRISE_ADMIN_DETAILS,
                    payload: enterpriseDetailsObj
                })

                dispatch({
                    type: ENTERPRISE_LEVELS_DETAILS,
                    payload: enterpriseLevelsDetailsObj
                })

                dispatch({
                    type: OWN_ROLE,
                    payload: ownRoleObj
                })
            } else {
                dispatch({
                    type: ENTERPRISE_ADMIN_DETAILS,
                    payload: null,
                })
            }
        } catch (e) {
            dispatch({
                type: ENTERPRISE_ADMIN_DETAILS,
                payload: null,
            })
        }
    }
